import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';

export default function VerifyEmailPage() {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const res = await fetch(`/api/candidate/verify/${token}`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Verification failed');
      }

      setStatus('success');
      setEmail(data.email || '');
      setMessage(data.message);
    } catch (err) {
      setStatus('error');
      setMessage(err.message);
    }
  };

  if (status === 'verifying') {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.loadingIcon}>⏳</div>
          <h1 style={styles.title}>Verifying Your Email...</h1>
          <p style={styles.text}>Please wait while we verify your email address.</p>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.successIcon}>✓</div>
          <h1 style={styles.title}>Email Verified!</h1>
          <p style={styles.text}>
            {message || 'Your email has been verified successfully.'}
          </p>
          {email && (
            <p style={styles.emailText}>
              <strong>{email}</strong>
            </p>
          )}
          <p style={styles.text}>You can now login to access your account.</p>
          <Link to="/login" style={styles.link}>
            Go to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.errorIcon}>✗</div>
        <h1 style={styles.title}>Verification Failed</h1>
        <p style={styles.text}>
          {message || 'The verification link is invalid or has expired.'}
        </p>
        <div style={styles.actions}>
          <Link to="/register" style={styles.link}>
            Register Again
          </Link>
          <Link to="/login" style={styles.secondaryLink}>
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a2f4d 0%, #2a4d6d 100%)',
    padding: '20px',
    fontFamily: "'Open Sans', sans-serif",
  },
  card: {
    background: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
    maxWidth: '500px',
    width: '100%',
    padding: '40px',
    textAlign: 'center',
  },
  loadingIcon: {
    fontSize: '64px',
    marginBottom: '20px',
    animation: 'pulse 1.5s infinite',
  },
  successIcon: {
    width: '80px',
    height: '80px',
    background: '#28a745',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    color: '#fff',
    margin: '0 auto 20px',
  },
  errorIcon: {
    width: '80px',
    height: '80px',
    background: '#dc3545',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '48px',
    color: '#fff',
    margin: '0 auto 20px',
  },
  title: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#1a2f4d',
    margin: '0 0 15px',
    fontFamily: "'Montserrat', sans-serif",
  },
  text: {
    fontSize: '14px',
    color: '#6c757d',
    margin: '0 0 15px',
    lineHeight: 1.6,
  },
  emailText: {
    fontSize: '16px',
    color: '#1a2f4d',
    margin: '0 0 20px',
  },
  link: {
    display: 'block',
    padding: '12px 24px',
    background: '#ff6b35',
    color: '#fff',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: 600,
    marginTop: '20px',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '20px',
  },
  secondaryLink: {
    display: 'block',
    padding: '12px 24px',
    background: '#1a2f4d',
    color: '#fff',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: 600,
  },
};
